import axios               from "@/axios/axios";
import $can                from "@/utils/abilities";
import * as apartmentTypes from '@/client/dictionaries/apartmentTypes';

const moduleUserActions = {
  GET_AUTH_USER:              async ( context ) => {
    try {
      let { data } = await axios.get('auth/user');
      context.commit('SET_USER_INFO', data);
      if (context.getters['type'] === 3) {
        await context.dispatch('common/GET_CLIENT_DATA', null, { root: true });
        await context.dispatch('client/GET_DATA');
      }
      if (context.getters['type'] === 2) {
        let date = new Date(localStorage.selected_month);
        if (Number.isNaN(+date)) date = new Date();
        context.dispatch('common/GET_EMPLOYEE_DATA', null, { root: true });
        context.commit('SET_APARTMENTS_TYPES', apartmentTypes.list.map(item => ({ id: item.id, name: item.title })));
        await Promise.all([
          context.dispatch("GET_PERMISSIONS"),
          context.dispatch("SET_DATE", date),
          context.dispatch("GET_HOUSES"),
        ]);
        // await new Promise(res => setTimeout(res, 5000));

        if ($can('issues', 'access', 'any')) {
          context.dispatch('common/tasks/GET_UNREAD_MESSAGES', null, { root: true });
        }

      }
    } catch (e) {
      context.commit('SET_UNAUTH');
    }
  },
  GET_PERMISSIONS:            async ( context ) => {
    try {
      let { data } = await axios.get('permissions');
      context.commit('SET_PERMISSIONS', data);
    } catch (e) {
      context.commit('SET_PERMISSIONS', []);
    }
  },
  GET_DEVICE_VALUES_SETTINGS: async ( context ) => {
    try {
      let { data } = await axios.get('u_device_values_settings', {
        params: {
          apartments_id: context.getters.apartment_id,
        },
      });
      context.commit('SET_DEVICES_SETTING', data);
    } catch (e) {
      context.commit('SET_DEVICES_SETTING', []);
    }
  },
  GET_RASH:                   async ( context ) => {
    try {
      let { data } = await axios.get('u_device_with_values', {
        params: {
          account_number: context.getters.account_number,
        },
      });


      if (data === 'apart is not passed') {
        context.commit('SET_RASH', []);
      } else {
        context.commit('SET_RASH', data);
      }
    } catch (e) {
      context.commit('SET_RASH', []);
    }
  },
  GET_PAYMENTS_TYPES:         async ( context ) => {
    try {
      let { data } = await axios.get('invoices_type');
      context.commit('SET_PAYMENTS_TYPES', data);
    } catch (e) {
      context.commit('SET_PAYMENTS_TYPES', []);
    }
  },
  GET_PAYMENTS:               async ( context ) => {
    try {
      let { data } = await axios.get('u_invoice', {
        params: {
          account_number: context.getters.account_number,
        },
      });
      context.commit('SET_PAYMENTS', data.invoices);
    } catch (e) {
      context.commit('SET_PAYMENTS', []);
    }

  },
  GET_DEVICE_TYPES:           async ( context ) => {
    let { data } = await axios.get('devices_type');
    context.commit('SET_DEVICE_TYPES', data);
  },
  UPDATE_SEND_CHARGE_EMAIL:   async ( context, payload ) => {
    try {
      await axios.put('apart_by_owner/' + context.getters.apartment_id, {
        send_charge_email: payload,
      });
      context.commit('SET_SEND_CHARGE_EMAIL', payload);
    } catch (e) {
      console.error(e);
    }
  },
  UPDATE_ACCOUNT_NUMBER:      async ( context, payload ) => {
    context.commit('SET_ACCOUNT_NUMBER', payload);
    await context.dispatch('GET_RASH');
    context.dispatch('client/GET_DATA');
    await context.dispatch('GET_DEVICE_VALUES_SETTINGS');
  },
  SAVE_USER:                  async ( context, payload ) => {
    let data = await axios.put('self_users/' + context.getters.id, payload);
    context.commit('SET_USER_INFO', data.user);
    return data;
  },
  UPDATE_USER_DATA:           async ( context ) => {
    let { data } = await axios.get('auth/user');
    context.commit('SET_USER_INFO', data);
  },
  LOGIN:                      async ( context, payload ) => {
    try {
      let { data } = await axios.post('auth/login', payload);
      localStorage.token = data.access_token;
      context.commit('UPDATE_TOKEN');
      await context.dispatch('GET_AUTH_USER');
      return true;
    } catch (e) {
      return false;
    }
  },
  LOGOUT:                     ( context ) => {
    localStorage.removeItem('token');
    context.commit('SET_UNAUTH');
  },
  GET_HOUSES:                 async ( context ) => {
    const mcs = context.rootGetters["appUser/management_companies_id"];
    return axios.get('houses', { params: { mcs, with_groups: true } }).then(( { data: buildingsRootGroup } ) => {
      const { buildings_id } = localStorage;

      const list = [];
      const extractGroup = ( group ) => {
        group.buildings.forEach(building => list.push(building));
        if (!Array.isArray(group.groups)) group.groups = Object.values(group.groups);
        group.groups.forEach(extractGroup);
      };
      extractGroup(buildingsRootGroup);

      if (buildings_id) {
        let house = list.find(house => house.id.toString() === buildings_id);
        if (house) {
          context.dispatch('UPDATE_SELECTED_HOUSE', house);
        } else {
          context.dispatch('UPDATE_SELECTED_HOUSE', list[0]);
        }
      } else {
        context.dispatch('UPDATE_SELECTED_HOUSE', list[0]);
      }
      context.commit('SET_HOUSES', { groups: buildingsRootGroup, list });
    });
  },
  UPDATE_SELECTED_HOUSE:      async ( context, payload ) => {
    localStorage.buildings_id = payload.id;
    context.commit('SET_SELECTED_HOUSE', payload);
  },
  SET_DATE:                   ( context, payload ) => {
    localStorage.selected_month = payload;
    context.commit('SET_DATE', payload);
  },
};

export default moduleUserActions;
